import LoadingSpinner, { LoadingSpinnerSize } from '../LoadingSpinner';
import { Spin } from 'antd';
import './loadingWrapper.less';

type LoadingWrapper = {
	isLoading: boolean;
	size?: LoadingSpinnerSize;
	children: React.ReactNode;
};

const LoadingWrapper = ({
	isLoading,
	size = LoadingSpinnerSize.small,
	children,
}): JSX.Element => {
	return (
		<Spin
			wrapperClassName="loading-wrapper"
			spinning={isLoading}
			indicator={<LoadingSpinner size={size} />}>
			{children}
		</Spin>
	);
};

export default LoadingWrapper;
